/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Advanced_Data_TitleInputs */

const en_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus Data Analysis`)
};

const ar_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل بيانات التركيز`)
};

const de_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus Datenanalyse`)
};

const es_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de datos de concentración`)
};

const fr_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse des données de concentration`)
};

const it_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi dei dati di concentrazione`)
};

const ja_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中データ分析`)
};

const ko_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 데이터 분석`)
};

const pt_br_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise dos dados de foco`)
};

const ru_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ данных фокусировки`)
};

const th_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวิเคราะห์ข้อมูลการโฟกัส`)
};

const tr_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Veri Analizi`)
};

const zh_cn_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注数据分析`)
};

const zh_tw_subscription_service_level_compare_advanced_data_title = /** @type {(inputs: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注數據分析`)
};

/**
* | output |
* | --- |
* | "Focus Data Analysis" |
*
* @param {Subscription_Service_Level_Compare_Advanced_Data_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_advanced_data_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Advanced_Data_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Advanced_Data_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_advanced_data_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_advanced_data_title(inputs)
	return zh_tw_subscription_service_level_compare_advanced_data_title(inputs)
});